import { ReactComponent as ArrowIcon } from './arrow.svg';

export const Icons = {
  ArrowIcon,
};
